import * as React from 'react'
import * as clsx from 'clsx'
import { IconWithText } from '@components/icon-with-text'
import { useToggle } from '@hooks/use-toggle'

interface Props {
  text: string | React.ReactElement
  initialHeight?: number
}

export const ExpandableText = ({ text, initialHeight }: Props): JSX.Element => {
  const [isExpanded, toggleIsExpended] = useToggle()

  const handleIsExpanded = (event: React.MouseEvent) => {
    event.preventDefault()
    toggleIsExpended()
  }

  return (
    <div>
      <small className={clsx('expandable-text', { 'is-expanded': isExpanded })} style={{ maxHeight: initialHeight }}>
        {text}
      </small>
      <ExpandIcon isExpanded={isExpanded} onIsExpandedChange={handleIsExpanded} />
    </div>
  )
}

interface ExpandIconParams {
  isExpanded: boolean
  onIsExpandedChange: (event: React.MouseEvent) => void
  wrapperClassName?: string
}

export const ExpandIcon = ({ isExpanded, onIsExpandedChange, wrapperClassName }: ExpandIconParams): JSX.Element => (
  <IconWithText
    text={isExpanded ? 'zwiń treść' : 'rozwiń treść'}
    textClassName="font-size-xxs fw-semi-bold"
    iconClassName="uil-angle-down expandable-text__arrow"
    onClick={onIsExpandedChange}
    wrapperClassName={clsx('expandable-text__action', wrapperClassName, { 'is-expanded': isExpanded })}
  />
)
